import { render, staticRenderFns } from "./CentroHospedaje.vue?vue&type=template&id=37c79f73&"
import script from "./CentroHospedaje.vue?vue&type=script&lang=js&"
export * from "./CentroHospedaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports